
const buildDisplayText = (carrierCode, dataArray) => {
  const ranges = dataArray
    .map(item =>
      item.flightNumberTo ? `${item.flightNumberFrom}-${item.flightNumberTo}` : item.flightNumberFrom
    )
    .join(", ");
  return `${carrierCode} ${ranges}`;
};

export const BLACKOUT_CARRIER_ACTION = {
    DELETE: "delete",
    CHANGE_EXCEPTION_TYPE: "changeType",
    TOGGLE_ALLER: "toggleAller",
    TOGGLE_RETOUR: "toggleRetour",
    UPDATE_DISPLAY_TEXT: "updateDisplayText",
    DELETE_INDEX: "deleteIndex",
}

export function createBlackOutCarrierPayload(obj) {
  const result = {};

  for (const prixKey in obj) {
    if (!obj.hasOwnProperty(prixKey)) continue;

    const items = obj[prixKey];
    const groupedMap = new Map();

    items.forEach(item => {
      const {
        carrierCode,
        exceptionType,
        aller = 0,
        retour = 0,
        flightNumberFrom,
        flightNumberTo
      } = item;

      const key = `${carrierCode}_${exceptionType}_${aller}_${retour}`;

      if (!groupedMap.has(key)) {
        groupedMap.set(key, {
          key,
          carrierCode,
          exceptionType,
          aller,
          retour,
          data: []
        });
      }

      groupedMap.get(key).data.push({
        flightNumberFrom,
        flightNumberTo: flightNumberTo || null
      });
    });

    const arr = Array.from(groupedMap.values()).map(group => ({
      ...group,
      displayText: buildDisplayText(group.carrierCode, group.data)
    }));

    result[prixKey] = arr;
  }

  return result;
}

export function reverseBlackOutCarrierPayload(nestedObj) {
  const result = {};

  for (const prixKey in nestedObj) {
    if (!nestedObj.hasOwnProperty(prixKey)) continue;

    result[prixKey] = [];
    nestedObj[prixKey].forEach(group => {
      if (group.isMarkedForDelete) return;
      const { carrierCode, exceptionType, aller, retour, data } = group;
      data.forEach(item => {
        result[prixKey].push({
          flightNumberFrom: item.flightNumberFrom,
          flightNumberTo: item.flightNumberTo,
          carrierCode,
          aller,
          retour,
          exceptionType
        });
      });
    });
  }

  return result;
}

export const applyAction = (payload, action, index, newValue = null, blackoutAirlinesRepetative = null, setBlackoutAirlinesRepetative = () => {}) => {
  const updatedState = JSON.parse(JSON.stringify(payload));

  for (const prixKey in updatedState) {
    if (!updatedState.hasOwnProperty(prixKey)) continue;

    const groupArray = updatedState[prixKey];
    if (!Array.isArray(groupArray)) continue;

    // Action: Update or Insert displayText
    if (action === "updateDisplayText") {
      if (!newValue) continue;

      const [carrierCode, ...rangeParts] = newValue.trim().split(" ");
      const ranges = rangeParts.join(" ").split(",");
      const parsedData = ranges.map(r => {
        const [from, to] = r.trim().split("-");
        return { flightNumberFrom: from, flightNumberTo: to || null };
      });

      if (index >= groupArray.length) {
        // Insert new entry
        const exceptionType = "BlackOut";
        const currentDataState = blackoutAirlinesRepetative[index] || {};
        const aller = currentDataState?.aller || 0;
        const retour = currentDataState?.retour || 0;
        const newKey = `${carrierCode}_${exceptionType}_${aller}_${retour}`;
        const displayText = buildDisplayText(carrierCode, parsedData);

        const existingIndex = groupArray.findIndex(item => item.key === newKey);
        if (existingIndex >= 0) {
          // Merge with existing
          const existing = groupArray[existingIndex];
          const mergedData = [...existing.data, ...parsedData];
          existing.data = deduplicateData(mergedData);
          existing.displayText = buildDisplayText(carrierCode, existing.data);
        } else {
          groupArray.push({
            key: newKey,
            carrierCode,
            exceptionType,
            aller,
            retour,
            displayText,
            data: parsedData
          });
        }
        continue;
      }

      // Update existing
      const current = groupArray[index];
      let { exceptionType, aller, retour } = current;
      const newKey = `${carrierCode}_${exceptionType}_${aller}_${retour}`;

      current.data = parsedData;
      current.carrierCode = carrierCode;
      current.displayText = buildDisplayText(carrierCode, parsedData);
      current.key = newKey;

      // Merge if key exists elsewhere
      const duplicateIndex = groupArray.findIndex((item, i) => i !== index && item.key === newKey);
      if (duplicateIndex >= 0) {
        const existing = groupArray[duplicateIndex];
        const mergedData = [...existing.data, ...current.data];
        existing.data = deduplicateData(mergedData);
        existing.displayText = buildDisplayText(carrierCode, existing.data);
        groupArray.splice(index, 1); // Remove old one
        const updated = [...blackoutAirlinesRepetative];
        updated[index] = { ...updated[index], isMarkedForDelete: false };
        // setBlackoutAirlinesRepetative(updated);
      }

      continue;
    }

    if (index < 0 || index >= groupArray.length) continue;

    const current = groupArray[index];
    let { carrierCode, exceptionType, aller, retour } = current;

    switch (action) {
      case "delete":
        current.isMarkedForDelete = !current.isMarkedForDelete;
        let data = JSON.parse(JSON.stringify(blackoutAirlinesRepetative));
        data[index].isMarkedForDelete = false;
        // setBlackoutAirlinesRepetative(data);
        continue;

      case "changeType":
        if (!newValue) continue;
        exceptionType = newValue;
        current.exceptionType = newValue;
        break;

      case "toggleAller":
        aller = aller === 1 ? 0 : 1;
        current.aller = aller;
        break;

      case "toggleRetour":
        retour = retour === 1 ? 0 : 1;
        current.retour = retour;
        break;

      default:
        console.error("Unknown action");
        continue;
    }

    const newKey = `${carrierCode}_${exceptionType}_${aller}_${retour}`;
    current.key = newKey;
    current.displayText = buildDisplayText(carrierCode, current.data);

    const duplicateIndex = groupArray.findIndex((item, i) => i !== index && item.key === newKey);
    if (duplicateIndex >= 0) {
      const existing = groupArray[duplicateIndex];
      const mergedData = [...existing.data, ...current.data];
      existing.data = deduplicateData(mergedData);
      existing.displayText = buildDisplayText(carrierCode, existing.data);
      groupArray.splice(index, 1);
      const updated = [...blackoutAirlinesRepetative];
      updated[index] = { ...updated[index], isMarkedForDelete: false };
      // setBlackoutAirlinesRepetative(updated);
    }
  }

  return updatedState;
};

function deduplicateData(arr) {
  return arr.filter(
    (item, idx, array) =>
      idx ===
      array.findIndex(
        t => t.flightNumberFrom === item.flightNumberFrom && t.flightNumberTo === item.flightNumberTo
      )
  );
}
